import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { BentoAlertItemOptions } from '@bento/bento-ng';
import { getBindings } from '@onviobr/services/session';
import { getEmployeeViews } from '@onviobr/services/core/employee-views';
import { ProfileReportsService } from '../../services/profile-reports.service';
import { EventEmitter, Output, Directive } from '@angular/core';
import { ReportTreeTypeRefresh } from '../../models/report';


@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class ReportProfileBase {
	// eslint-disable-next-line @angular-eslint/no-output-native
	@Output() success: EventEmitter<ReportTreeTypeRefresh> = new EventEmitter();

	companyId: string;
	contactId: string;
	employeeId: string;

	/** store selected profileId */
	profileId: string;

	/** store full proflie detail */
	profileDetail: any;

	/** form control */
	profileForm: FormGroup; // = new FormGroup({});

	isLoaderBusy = false;
	profileNameCheckLoader = false;
	alerts: BentoAlertItemOptions[] = [];
	getEmployeeViews = getEmployeeViews;
	/** get genral information of logged in user */
	getBindings = getBindings;

	/** Store validation messages for profileForm Control */
	abstract validations: any;

	get reportsFA(): FormArray {
		return this.profileForm.get('reportProfileSelections') as FormArray;
	}

	/** Used to form submit allowed */
	get isSubmitAllowed(): boolean {
		return !this.profileNameCheckLoader && this.profileForm.valid;
	}

	get isStaffTypeProfile(): boolean {
		return this.profileForm.get('profileType').value === 'Staff' ? true : false;
	}

	get employeeIdByProfileType(): string | null {
		// firm type not required emplloyeeId
		return this.isStaffTypeProfile ? this.employeeId : null;
	}
	constructor(public fb: FormBuilder, public profileReportsService: ProfileReportsService) {
	}

	/** handle error if failed to save report profile */
	saveProfileError(response: HttpErrorResponse): void {
		this.isLoaderBusy = false;
		if (response.status === 400) {
			this.handleBadRequest(response.error.error.errors);
		}
	}

	/** handle bad request  */
	handleBadRequest(errors: Array<any>): void {
		errors.forEach(element => {
			this.profileForm.get(element.locationField).setErrors(
				{
					[element.reason]: true
				});
		});
	}

	/** display alert messages */
	showAlerts(type: string = 'danger', message: string = 'Unable to save. Please fix any errors and try again.'): void {
		this.alerts.push({
			type,
			msg: message,
			closeable: true
		});
	}

	/** used to trigger request for refresh profile based on firm type */
	refreshSingleProfileTree() {
		// base on profile type pass key.
		const treeKey = this.isStaffTypeProfile ? 'isStaffChange' : 'isFirmChange';
		const reportTreeTypeRefresh = {
			[treeKey]: true
		};
		this.success.emit(reportTreeTypeRefresh as ReportTreeTypeRefresh);
	}

	/** used to display error message below to control if user directly click save button without filling form */
	markFormGroupTouched(formGroup: FormGroup) {
		(Object as any).values(formGroup.controls).forEach(control => {
			if (control.controls && control.invalid) { // control is a FormGroup
				this.markFormGroupTouched(control);
			} else if (control.invalid) { // control is a FormControl
				control.markAsTouched();
			}
		});
	}

	isControlInValid(controlName: string): boolean {
		return this.profileForm.get(controlName).invalid && this.profileForm.get(controlName).touched;
	}

	mapDate(from: any, to: any) {
		if (from.multidate && from.multidate.startDate) {
			to.startDate = new Date(from.multidate.startDate);
			to.endDate = new Date(from.multidate.endDate);
		}
		return to;
	}

	setControlValue(controlName: string, value: any): void {
		this.profileForm.get(controlName).setValue(value);
	}

	disableControl(name: string) {
		this.profileForm.get(name).disable();
	}

	enableControl(name: string) {
		this.profileForm.get(name).enable();
	}
	readProfileDetail() {
		if (!this.profileId) {
			throw Error('Profile Id not present for read profile detail.');
		}
		this.isLoaderBusy = true;
		this.profileReportsService.readReportProfile(this.companyId, this.profileId)
			.subscribe(info => {
				this.profileDetail = info;
				this.setValueBeforePatch();
				this.profileForm.patchValue(info);
				this.setValueAfterPatch();
			}, () => this.isLoaderBusy = false,
			() => this.isLoaderBusy = false
			);
	}
	validateUniqueness() {
		const profileName = this.profileForm.get('name').value;
		if (!profileName) {
			return;
		}
		this.profileNameCheckLoader = true;
		this.profileReportsService.verifyUniqueValueForProfile(this.companyId, profileName, this.profileId, this.employeeIdByProfileType)
			.subscribe((isValid) => {
				const control = this.profileForm.get('name');
				if (!isValid.value) {
					control.setErrors(
						{
							// eslint-disable-next-line @typescript-eslint/naming-convention
							ReportProfileNameMustBeUnique: true
						});
				} else {
					control.clearValidators();
					control.setValidators([Validators.required]);
					control.updateValueAndValidity();
				}

			},
			() => this.profileNameCheckLoader = false,
			() => this.profileNameCheckLoader = false
			);
	}

	async readEmployeeId() {
		const employeeId = await this.profileReportsService.readEmployeeId(this.companyId, this.contactId);
		this.employeeId = employeeId;

	}

	/** component lifecycle */
	// Linter currently unable to handle abstract version of ngOnInit in base class.
	// eslint-disable-next-line @angular-eslint/use-lifecycle-interface
	abstract ngOnInit();

	/** initialize Reactive form control */
	abstract formControlInit(): any;

	/** user click on Save button */
	abstract profileSubmit();

	/** used to call Save profile service */
	abstract saveProfile(employeeId?: string): void;

	/** handle success after profile saved */
	abstract saveProfileSuccess(data: any): void;

	abstract setValueBeforePatch();

	abstract setValueAfterPatch();
}
